import { connect } from 'react-redux'

/** HOC to make the 'user profile' of the current user
 * available as prop `userProfile` to the wrapped component. */
const withCdnUrl = connect((state = {}) => ({
  cdnUrl : state.cdnUrl || '/'
}))

export default withCdnUrl



// WEBPACK FOOTER //
// ./src/common/ui/components/withCdnUrl.js